import React, { useState } from "react";

const StripePricingTable = () => {
  const [billingCycle, setBillingCycle] = useState("yearly");

  const pricingOptions = {
    monthly: [
      {
        plan: "Business",
        price: "$79",
        period: "per month",
        features: [
          "Corporate Analytics",
          "Sales and Traffic Reporting",
          "Enterprise Conversion Tracking",
        ],
        stripeUrl: "/checkout?subscription=monthly_business",
      },
      {
        plan: "Enterprise",
        price: "$109",
        period: "per month",
        features: ["AI revenue modeling", "AI inventory modeling"],
        stripeUrl: "/checkout?subscription=monthly_enterprise",
      },
    ],
    yearly: [
      {
        plan: "Business",
        price: "$749",
        period: "per year",
        features: [
          "Corporate Analytics",
          "Sales and Traffic Reporting",
          "Enterprise Conversion Tracking",
        ],
        stripeUrl: "/checkout?subscription=yearly_business",
      },
      {
        plan: "Enterprise",
        price: "$1,049",
        period: "per year",
        features: ["AI revenue modeling", "AI inventory modeling"],
        stripeUrl: "/checkout?subscription=yearly_enterprise",
      }
    ],
  };

  const handleSubscribe = (url) => {
    window.location.href = url;
  };

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      fontFamily: "Arial, sans-serif",
      padding: "20px",
      backgroundColor: "#f8f9fa",
      minHeight: "100vh",
    },
    toggleContainer: {
      display: "flex",
      backgroundColor: "#e0e0e0",
      borderRadius: "8px",
      padding: "5px",
      marginBottom: "20px",
    },
    toggleButton: (active) => ({
      padding: "10px 20px",
      borderRadius: "8px",
      cursor: "pointer",
      backgroundColor: active ? "rgb(0, 96, 122)" : "transparent",
      color: active ? "white" : "#333",
      border: "none",
      fontWeight: "bold",
    }),
    pricingGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "20px",
      width: "100%",
      maxWidth: "800px",
    },
    card: {
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "8px",
      textAlign: "center",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      border: "1px solid #ddd",
    },
    title: {
      fontSize: "22px",
      fontWeight: "bold",
    },
    price: {
      fontSize: "30px",
      fontWeight: "bold",
      marginTop: "10px",
    },
    period: {
      color: "#666",
    },
    subscribeButton: {
      marginTop: "15px",
      padding: "10px 20px",
      backgroundColor: "rgb(0, 96, 122)",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
    },
    featureList: {
      marginTop: "15px",
      color: "#555",
      textAlign: "left",
      paddingLeft: "20px",
    },
    featureItem: {
      marginBottom: "5px",
    },
  };

  return (
    <div style={styles.container}>
      {/* Tab Toggle */}
      <div style={styles.toggleContainer}>
        <button
          style={styles.toggleButton(billingCycle === "monthly")}
          onClick={() => setBillingCycle("monthly")}
        >
          Monthly
        </button>
        <button
          style={styles.toggleButton(billingCycle === "yearly")}
          onClick={() => setBillingCycle("yearly")}
        >
          Yearly
        </button>
      </div>

      {/* Pricing Cards */}
      <div style={styles.pricingGrid}>
        {pricingOptions[billingCycle].map((option, index) => (
          <div key={index} style={styles.card}>
            <h2 style={styles.title}>{option.plan}</h2>
            <p style={styles.price}>{option.price}</p>
            <p style={styles.period}>{option.period}</p>
            <button
              style={styles.subscribeButton}
              onClick={() => handleSubscribe(option.stripeUrl)}
            >
              Start 7-day free trial
            </button>
            <ul style={styles.featureList}>
              {option.features.map((feature, idx) => (
                <li key={idx} style={styles.featureItem}>
                  ✅ {feature}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

       {/* Terms and Conditions */}
       <p style={{ marginTop: 30, color: "#666", fontSize: 15, textAlign: "center" }}>
       By proceeding with checkout, you agree to our{" "}
       <a href="https://gaiiff.com/termsofservice/" target="_blank" rel="noopener noreferrer">
         Terms and Conditions
       </a>.
     </p>
    </div>
  );
};

export default StripePricingTable;
